"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactStringReplace = _interopRequireDefault(require("react-string-replace"));
var _i18n = _interopRequireDefault(require("../../util/i18n.js"));
var _DetailsRow = _interopRequireDefault(require("./DetailsRow"));
require("./DetailsTable.css");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
class DetailsTable extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      i18n: this.props.translationDictionary ? this.props.translationDictionary : _i18n.default
    };
  }
  // create the rows
  renderRows() {
    const {
      data
    } = this.props;

    // Filter out Benchmarks and Common Stock, and Crypto
    return data.filter(x => x.type !== 'BMK' && x.type !== 'WTIDX' && x.type !== 'CS' && x.type !== 'CY' && x.ticker !== '$CASH').map((fund, index) => {
      return /*#__PURE__*/_react.default.createElement(_DetailsRow.default, {
        key: fund.externalID,
        index: index,
        fund: fund
      });
    });
  }

  // create the header
  renderHeader() {
    const {
      i18n
    } = this.state;
    const {
      data
    } = this.props;
    const stdPerformance = Array.isArray(data[0].stdPerformance) ? data[0].stdPerformance[0] : data[0].stdPerformance;
    const asOfDate = new Date(stdPerformance.asOfDate).toLocaleDateString();
    return /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textLeft ticker sticky"
    }, i18n.t('Ticker')), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textCenter filings"
    }, i18n.t('Website')), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textCenter filings"
    }, i18n.t('Filings')), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textCenter category"
    }, i18n.t('Inception Date')), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textCenter fees"
    }, i18n.t('Gross Expense Ratio')), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textCenter fees"
    }, i18n.t('Net Expense Ratio')), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textCenter date"
    }, i18n.t('30-Day SEC Yield, Subsidized'), " (", i18n.t('as of'), " ", asOfDate, ")"), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "textCenter date"
    }, i18n.t('30-Day SEC Yield, Unsubsidized'), " (", i18n.t('as of'), " ", asOfDate, ")"), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: 'col-md-3 textCenter date'
    }, i18n.t('Notes'))));
  }
  render() {
    const {
      footnote
    } = this.props;
    let formattedFootnoteText;
    if (footnote) {
      formattedFootnoteText = (0, _reactStringReplace.default)(footnote, '<br/>', match => /*#__PURE__*/_react.default.createElement("br", {
        key: Math.random()
      }));
      formattedFootnoteText = (0, _reactStringReplace.default)(formattedFootnoteText, /<strong>(.*)<\/strong>/g, match => /*#__PURE__*/_react.default.createElement("strong", {
        key: Math.random()
      }, match));
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "details-table-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "table-responsive"
    }, /*#__PURE__*/_react.default.createElement("table", {
      className: 'table'
    }, this.renderHeader(), /*#__PURE__*/_react.default.createElement("tbody", null, this.renderRows()))), formattedFootnoteText ? /*#__PURE__*/_react.default.createElement("div", {
      className: "perf-footnote"
    }, formattedFootnoteText) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null)));
  }
}
_defineProperty(DetailsTable, "defaultProps", {
  data: null,
  translationDictionary: null,
  showTitle: true
});
DetailsTable.propTypes = {
  /**
   * Fund data to be used for Performance. Should be array of funds
   */
  data: _propTypes.default.array.isRequired,
  /**
   * Translation dictionary (i18) - needed for tables, but can default to included version
   */
  translationDictionary: _propTypes.default.object,
  /**
   * Show the title or not
   */
  showTitle: _propTypes.default.bool,
  /**
   * Footnote text
   */
  footnote: _propTypes.default.string
};
var _default = exports.default = DetailsTable;